import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { getListReturnTo } from '@/lib/navigation/listReturnTo'

/**
 * Navigate back to the filtered list URL stored in location.state, or `fallback`.
 */
export function useNavigateToList(fallback: string) {
  const navigate = useNavigate()
  const location = useLocation()

  return useCallback(
    (options?: { replace?: boolean }) => {
      navigate(getListReturnTo(location.state, fallback), {
        replace: options?.replace,
      })
    },
    [navigate, location.state, fallback],
  )
}
